import { Box } from "@mui/material";
import { style } from "./mobileMenu.style";

export const MobileMenuSection = ({ title, children }) => (
  <Box sx={style.section} className="mobile-menu__section">
    {title && <Box component="span" sx={style.title} className="mobile-menu__title">{title}</Box>}
    <ul>{children}</ul>
  </Box>
);
